import React from 'react';
import { IRangePickerProps } from '../interface';
import DateRangePicker from './DateRangePicker';
import MonthRangePicker from './MonthRangePicker';
import YearRangePicker from './YearRangePicker';

const RangePicker: React.FC<IRangePickerProps> = props => {
  const { refs, picker, ...rest } = props;

  switch (picker) {
    case 'month':
      return <MonthRangePicker ref={refs} {...rest} />;
    case 'year':
      return <YearRangePicker ref={refs} {...rest} />;
    default:
      return <DateRangePicker ref={refs} {...rest} />;
  }
};

export { IRangePickerProps };

export default RangePicker;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSDatePicker/RangePicker/index.tsx